(function(){
/* MasalSensin Wizard — 4-step flow (Kahraman / Cinsiyet / Fotoğraflar+Cloudinary / Hazırlayan+İlişki / Not)
   Yaş adımı kaldırıldı. Fotoğraflar Cloudinary'ye (unsigned preset) yüklenir, secure_url properties'e yazılır. */

var CLOUDINARY_CLOUD='dd7r5p0nd';
var CLOUDINARY_PRESET='masalsensin_customer_photos';

var step=0,gender='',photos=[],photoUrls=[],iliski='',variantId=0;
var iliskiSel=[], hazAuto='';
var KW_POSS={'Anne':'Annen','Baba':'Baban','Anneanne':'Anneannen','Babaanne':'Babaannen','Dede':'Deden','Nine':'Ninen','Teyze':'Teyzen','Hala':'Halan','Amca':'Amcan','Dayı':'Dayın','Yenge':'Yengen','Enişte':'Enişten','Ağabey':'Ağabeyin','Abla':'Ablan','Arkadaş':'Arkadaşın'};
var uploadingCount=0;
var editLineKey=null;  // set when user arrived via "Bilgileri düzenle" from cart
var variantExplicit=false; // true when a caller passed a specific variant (msWizOpenForVariant / msWizOpenPrefilled / edit mode)
var lastFocus=null;   // element focused before the dialog opened (focus returns here on close)
var overlay=document.getElementById('ms-wiz-overlay');
if(!overlay)return;
var steps=overlay.querySelectorAll('.kw-step');
var dots=overlay.querySelectorAll('.kw-dot');
var LAST_STEP=3;

// Get variant ID from product page
var form=document.querySelector('form[action*="/cart/add"]');
if(form){
  var vid=form.querySelector('[name="id"]');
  if(vid)variantId=parseInt(vid.value);
}

// Edit mode: if we arrived from cart with ?edit_cart=1, hydrate form from localStorage
try {
  if (location.search.indexOf('edit_cart=1') >= 0) {
    var raw = localStorage.getItem('ms_wiz_edit_state');
    if (raw) {
      var saved = JSON.parse(raw);
      if (saved && saved.ts && (Date.now() - saved.ts) < 3600000) {
        editLineKey = saved.lineKey;
        if (saved.variantId) { variantId = saved.variantId; variantExplicit = true; }
        var hydrate = function() {
          var nameInput = document.getElementById('kw-name');
          var hazInput  = document.getElementById('kw-hazirlayan');
          var noteInput = document.getElementById('kw-note');
          if (nameInput) nameInput.value = saved.kahraman || '';
          if (hazInput)  hazInput.value  = saved.hazirlayan || '';
          if (noteInput) noteInput.value = saved.not || '';
          if (saved.cinsiyet) {
            var g = saved.cinsiyet === 'Kız' ? 'kiz' : 'erkek';
            var gEl = document.querySelector('#kw-gender .kw-opt[data-val="' + g + '"]');
            if (gEl) { gEl.classList.add('active'); gender = g; }
          }
          if (saved.iliski) {
            var savedParts = String(saved.iliski).split(' ve ');
            document.querySelectorAll('#kw-iliski .kw-chip').forEach(function(el){
              if (savedParts.indexOf(el.dataset.val) >= 0) { el.classList.add('active'); if(iliskiSel.indexOf(el.dataset.val)<0) iliskiSel.push(el.dataset.val); }
            });
            iliski = iliskiSel.join(' ve ');
          }
          // Restore uploaded URLs if present (so we don't re-upload)
          if (Array.isArray(saved.photoUrls) && saved.photoUrls.length >= 1) {
            photoUrls = saved.photoUrls.slice(0, 5);
            photos = photoUrls.map(function(){ return new File([new Uint8Array([0])],'_kept.jpg',{type:'image/jpeg'}); });
            var dz = document.getElementById('kw-photos');
            if (dz) dz.classList.add('has');
            var count = document.getElementById('kw-count');
            if (count) count.textContent = 'Mevcut fotoğraflar korunacak';
          }
          localStorage.removeItem('ms_wiz_edit_state');
          try { history.replaceState({}, '', location.pathname); } catch(_) {}
          setTimeout(function(){ if (window.msWizOpen) msWizOpen(); }, 400);
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hydrate);
        else hydrate();
      } else {
        localStorage.removeItem('ms_wiz_edit_state');
      }
    }
  }
} catch (e) { /* silent */ }

/* a11y (audit H5, 2026-10-11): focus moves into the dialog on open, Tab is trapped inside, Escape closes, focus returns on close */
function kwFocusables(){
  return [].filter.call(overlay.querySelectorAll('button:not([disabled]),input:not([type="hidden"]):not([disabled]),[tabindex="0"],a[href]'),function(x){
    return x.offsetParent!==null && getComputedStyle(x).visibility!=='hidden';
  });
}
function kwFocusStep(){
  var act=steps[step]; if(!act) return;
  var t=act.querySelector('input.kw-input,[role="radio"],.kw-drop,button.kw-chip');
  if(t&&t.offsetParent!==null){ try{t.focus({preventScroll:true});}catch(_){t.focus();} }
  else { var c=overlay.querySelector('.kw-card'); if(c) c.focus(); }
}
window.msWizOpen=function(){
  if(overlay.style.display!=='flex'){ var ae=document.activeElement; lastFocus=(ae&&ae!==document.body)?ae:null; }
  overlay.style.display='flex';document.documentElement.classList.add('kw-lock');step=0;goStep(0);
  var pop=document.getElementById('ms-popup-overlay');if(pop)pop.classList.remove('show');
  setTimeout(kwFocusStep,60);
};
overlay.addEventListener('keydown',function(e){
  if(overlay.style.display==='none') return;
  if(e.key==='Escape'||e.key==='Esc'){ e.preventDefault(); msWizClose(); return; }
  if(e.key!=='Tab') return;
  var f=kwFocusables(); if(!f.length) return;
  var a=f[0], z=f[f.length-1], cur=document.activeElement;
  if(!overlay.contains(cur)){ e.preventDefault(); a.focus(); return; }
  if(e.shiftKey && cur===a){ e.preventDefault(); z.focus(); }
  else if(!e.shiftKey && cur===z){ e.preventDefault(); a.focus(); }
});
/* Escape also works when focus is outside the overlay (e.g. after a click on the backdrop area) */
document.addEventListener('keydown',function(e){ if((e.key==='Escape'||e.key==='Esc') && overlay.style.display==='flex' && !overlay.contains(document.activeElement)) msWizClose(); });
window.msWizOpenForVariant=function(vid){
  var n=parseInt(vid,10);
  if(n&&!isNaN(n)){variantId=n;variantExplicit=true;}
  window.msWizOpen();
};
window.msWizOpenPrefilled=function(vid,prefill){
  var n=parseInt(vid,10);
  if(n&&!isNaN(n)){variantId=n;variantExplicit=true;}
  if(prefill){
    var nameInput=document.getElementById('kw-name');
    if(nameInput&&prefill.kahraman)nameInput.value=prefill.kahraman;
    if(prefill.cinsiyet){
      var g=prefill.cinsiyet==='Kız'?'kiz':(prefill.cinsiyet==='Erkek'?'erkek':'');
      if(g){
        document.querySelectorAll('#kw-gender .kw-opt').forEach(function(o){o.classList.remove('active')});
        var gEl=document.querySelector('#kw-gender .kw-opt[data-val="'+g+'"]');
        if(gEl){gEl.classList.add('active');gender=g;}
      }
    }
    var hazInput=document.getElementById('kw-hazirlayan');
    if(hazInput&&prefill.hazirlayan)hazInput.value=prefill.hazirlayan;
    if(prefill.iliski){
      var prefParts=String(prefill.iliski).split(' ve ');
      iliskiSel=[];
      document.querySelectorAll('#kw-iliski .kw-chip').forEach(function(el){
        el.classList.remove('active');
        if(prefParts.indexOf(el.dataset.val)>=0){el.classList.add('active');iliskiSel.push(el.dataset.val);}
      });
      iliski=iliskiSel.join(' ve ');
    }
    // Photos: if URLs provided, reuse. Else placeholder.
    if(Array.isArray(prefill.photoUrls)&&prefill.photoUrls.length>=1){
      photoUrls=prefill.photoUrls.slice(0,5);
      photos=photoUrls.map(function(){return new File([new Uint8Array([0])],'_kept.jpg',{type:'image/jpeg'})});
    } else {
      var placeholder=new File([new Uint8Array([0])],'_kept.jpg',{type:'image/jpeg'});
      photos=[placeholder,placeholder];
      photoUrls=[];
    }
    var dz=document.getElementById('kw-photos');
    if(dz)dz.classList.add('has');
    var countEl=document.getElementById('kw-count');
    if(countEl)countEl.textContent='Önceki kitaptaki fotoğraflar kullanılacak; isterseniz değiştirebilirsiniz.';
  }
  window.msWizOpen();
};
window.msWizClose=function(){
  overlay.style.display='none';document.documentElement.classList.remove('kw-lock');
  var lf=lastFocus; lastFocus=null;
  if(lf&&lf.focus&&document.contains(lf)){ try{lf.focus({preventScroll:true});}catch(_){lf.focus();} }
};
window.kwGender=function(el){
  document.querySelectorAll('#kw-gender .kw-opt').forEach(function(o){o.classList.remove('active')});
  el.classList.add('active');gender=el.dataset.val;kwCheck();
};
/* radiogroup arrow keys (Left/Right/Up/Down move + select), Enter/Space already handled inline */
(function(){
  var g=document.getElementById('kw-gender'); if(!g) return;
  g.addEventListener('keydown',function(e){
    if(['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].indexOf(e.key)<0) return;
    var opts=[].slice.call(g.querySelectorAll('[role="radio"]')); var i=opts.indexOf(document.activeElement); if(i<0) return;
    e.preventDefault(); var n=opts[(i+((e.key==='ArrowLeft'||e.key==='ArrowUp')?-1:1)+opts.length)%opts.length];
    n.focus(); kwGender(n);
  });
})();
/* keep ARIA state in sync with the visual .active state (also after edit-mode hydrate / prefill) */
function kwSyncAria(){
  overlay.querySelectorAll('#kw-gender [role="radio"]').forEach(function(o){ o.setAttribute('aria-checked', o.classList.contains('active')?'true':'false'); });
  var full=iliskiSel.length>=2;
  overlay.querySelectorAll('#kw-iliski .kw-chip').forEach(function(c){
    var on=c.classList.contains('active');
    c.setAttribute('aria-pressed', on?'true':'false');
    if(full&&!on) c.setAttribute('aria-disabled','true'); else c.removeAttribute('aria-disabled');
  });
}
window.kwIliski=function(el){
  var val=el.dataset.val;
  var idx=iliskiSel.indexOf(val);
  if(idx>=0){ iliskiSel.splice(idx,1); el.classList.remove('active'); }
  else { if(iliskiSel.length>=2){ return; } iliskiSel.push(val); el.classList.add('active'); }
  iliski=iliskiSel.join(' ve ');
  // 2 ilişki seçilince "Hazırlayan"ı iyelikli otomatik doldur (kullanıcı düzenleyebilir)
  var haz=document.getElementById('kw-hazirlayan');
  if(haz){
    var suggest = iliskiSel.length===2 ? iliskiSel.map(function(r){return KW_POSS[r]||r;}).join(' ve ') : '';
    if(suggest && (haz.value.trim()==='' || haz.value===hazAuto)){ haz.value=suggest; hazAuto=suggest; }
    else if(!suggest && haz.value===hazAuto){ haz.value=''; hazAuto=''; }
  }
  kwCheck();
};

/* Client-side resize (canvas) to max 1600px longest edge, JPEG q=0.85.
   3-5 MB telefon fotoğrafını ~200-400 KB'a düşürür → upload 5-10x hızlanır. */
function resizeImage(file){
  return new Promise(function(resolve, reject){
    var url = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function(){
      var maxSide = 1600;
      var w = img.naturalWidth, h = img.naturalHeight;
      if (w > maxSide || h > maxSide) {
        if (w >= h) { h = Math.round(h * maxSide / w); w = maxSide; }
        else        { w = Math.round(w * maxSide / h); h = maxSide; }
      }
      var canvas = document.createElement('canvas');
      canvas.width = w; canvas.height = h;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, w, h);
      canvas.toBlob(function(blob){
        URL.revokeObjectURL(url);
        if (!blob) return reject(new Error('resize fail'));
        resolve(blob);
      }, 'image/jpeg', 0.85);
    };
    img.onerror = function(){ URL.revokeObjectURL(url); reject(new Error('img load fail')); };
    img.src = url;
  });
}

/* Upload single file to Cloudinary unsigned, return secure_url (with retries). */
function cloudinaryUpload(file){
  var endpoint = 'https://api.cloudinary.com/v1_1/' + CLOUDINARY_CLOUD + '/image/upload';
  return resizeImage(file).catch(function(){ return file; }).then(function(blob){
    return new Promise(function(resolve, reject){
      var attempt = 0;
      function doFetch(){
        attempt++;
        var fd = new FormData();
        fd.append('upload_preset', CLOUDINARY_PRESET);
        fd.append('file', blob);
        fetch(endpoint, { method:'POST', body:fd })
          .then(function(r){ return r.json(); })
          .then(function(data){
            if (data && data.secure_url) resolve(data.secure_url);
            else if (attempt<3) setTimeout(doFetch, 1500);
            else reject(new Error('cloudinary fail: ' + (data && data.error && data.error.message || 'unknown')));
          })
          .catch(function(e){
            if (attempt<3) setTimeout(doFetch, 1500);
            else reject(e);
          });
      }
      doFetch();
    });
  });
}

window.kwPhotos=function(input){
  photos = Array.from(input.files).slice(0,5);
  photoUrls = []; // reset
  var t = document.getElementById('kw-thumbs'); t.innerHTML='';
  var countEl = document.getElementById('kw-count');
  photos.forEach(function(f){
    var i=document.createElement('img');
    i.src=URL.createObjectURL(f);
    t.appendChild(i);
  });
  document.getElementById('kw-photos').classList.toggle('has', photos.length>0);
  if (photos.length===0){ if(countEl)countEl.textContent=''; kwCheck(); return; }
  if(countEl)countEl.textContent = 'Yükleniyor… 0/'+photos.length;
  uploadingCount = photos.length;
  document.getElementById('kw-photos').classList.add('is-uploading');
  // Parallel upload to Cloudinary (no rate limit issue like imgbb)
  var done = 0;
  photoUrls = new Array(photos.length);
  var tasks = photos.map(function(f, i){
    return cloudinaryUpload(f).then(function(url){
      photoUrls[i] = url;
      done++;
      if(countEl)countEl.textContent = 'Yükleniyor… '+done+'/'+photos.length;
      kwCheck();
    });
  });
  Promise.all(tasks).then(function(){
    if(countEl){countEl.textContent = photos.length+' fotoğraf yüklendi ✓'; countEl.style.color='';}
    uploadingCount = 0;
    document.getElementById('kw-photos').classList.remove('is-uploading');
    kwCheck();
  }).catch(function(err){
    if(countEl){countEl.textContent='Fotoğraf yüklenemedi, lütfen yeniden seçin'; countEl.style.color='#b5341a';}
    uploadingCount = 0;
    document.getElementById('kw-photos').classList.remove('is-uploading');
    photoUrls = [];
    document.getElementById('kw-photos').classList.remove('has');
    kwCheck();
  });
};
window.kwCheck=function(){
  var ok=false;
  if(step===0) ok = document.getElementById('kw-name').value.trim().length>0;
  if(step===1) ok = !!gender; // Yaş kaldırıldı
  if(step===2) ok = photos.length>=1 && photoUrls.length>=1 && uploadingCount===0;
  if(step===3) ok = document.getElementById('kw-hazirlayan').value.trim().length>0 && !!iliski;
  var nb=document.getElementById('kw-next');
  nb.disabled = !ok;
  nb.style.opacity = ok ? '1' : '0.3';
  document.getElementById('kw-err').style.display='none';
  try{kwSide();}catch(_){}
  try{kwSyncAria();}catch(_){}
};
function goStep(s){
  step=s;
  steps.forEach(function(el,i){el.classList.toggle('active',i===s)});
  dots.forEach(function(d,i){
    d.classList.toggle('done', i<s);
    if(i<s){d.style.background='var(--ms-orange)';d.classList.remove('active');}
    else if(i===s){d.style.background='';d.classList.add('active');}
    else{d.style.background='#e8e2da';d.classList.remove('active');}
  });
  document.getElementById('kw-back').style.display = s>0 ? 'block' : 'none';
  document.getElementById('kw-next').textContent = s===LAST_STEP ? 'Sepete Ekle' : 'Devam';
  var kb=overlay.querySelector('.kw-body'); if(kb)kb.scrollTop=0;
  kwCheck();
}
window.kwNext=function(){
  if(document.getElementById('kw-next').disabled)return;
  if(step<LAST_STEP){goStep(step+1);kwFocusTitle();return}
  var name=document.getElementById('kw-name').value.trim();
  var hazirlayan=document.getElementById('kw-hazirlayan').value.trim();
  if(!name || !gender || photoUrls.length<1 || !hazirlayan || !iliski){
    document.getElementById('kw-err').textContent='Lütfen tüm alanları doldurun; en az bir fotoğrafın yüklenmiş olması gerekir.';
    document.getElementById('kw-err').style.display='block';return;
  }
  var properties = {
    'Kahraman': name,
    'Cinsiyet': gender==='kiz' ? 'Kız' : 'Erkek',
    'Fotoğraf 1': photoUrls[0],
    'Hazırlayan': hazirlayan,
    'İlişki': iliski
  };
  /* 12 Oct: hidden display props for the cart / added sheet (underscore = not shown at checkout) */
  properties['_Kapak'] = kwCoverTitle(name);
  properties['_Hediye'] = kwGiftLine(name, iliski);
  if (photoUrls[1]) properties['Fotoğraf 2'] = photoUrls[1];
  if (photoUrls[2]) properties['Fotoğraf 3'] = photoUrls[2];
  if (photoUrls[3]) properties['Fotoğraf 4'] = photoUrls[3];
  if (photoUrls[4]) properties['Fotoğraf 5'] = photoUrls[4];
  /* read the currently selected variant at submit time (audit WIZ-H) unless a caller / edit mode fixed it */
  if(!variantExplicit){
    var vEl=document.querySelector('[data-msb-variant-id]')||document.querySelector('form[action*="/cart/add"] [name="id"]');
    var vNow=vEl?parseInt(vEl.value,10):0; if(vNow&&!isNaN(vNow)) variantId=vNow;
  }
  var body={items:[{id:variantId,quantity:1,properties:properties}]};
  var nb=document.getElementById('kw-next'), errEl=document.getElementById('kw-err');
  nb.textContent=editLineKey?'Güncelleniyor...':'Ekleniyor...';
  nb.disabled=true;
  /* audit WIZ-H (2026-10-11): non-2xx = inline error, no redirect; edit mode removes the old line ONLY after the new one was added */
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
  .then(function(r){
    return r.text().then(function(t){
      var d=null; try{ d=JSON.parse(t); }catch(_){}
      if(!r.ok){ var m=(d&&(d.description||d.message))||('HTTP '+r.status); var er=new Error(m); er.kwHttp=r.status; throw er; }
      return d;
    });
  })
  .then(function(){
    if (editLineKey) {
      return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:editLineKey,quantity:0})})
        .catch(function(){ /* new line is in the cart; old one can still be removed on the cart page */ })
        .then(function(){ window.location.href='/cart'; });
    }
    var kwItem=(arguments[0]&&arguments[0].items&&arguments[0].items[0])||null;
    nb.textContent='Sepete Ekle'; nb.disabled=false; nb.style.opacity='1';
    /* 12 Oct: Reha — no interstitial card, go straight to the cart (window.msAddedSheet kept unused) */
    window.location.href='/cart';
  })
  .catch(function(e){
    var msg=e&&e.kwHttp ? 'Sepete eklenemedi: '+e.message+' Lütfen tekrar deneyin ya da WhatsApp\'tan bize yazın.' : 'Sepete eklenemedi, bağlantınızı kontrol edip tekrar deneyin.';
    errEl.textContent=msg;
    errEl.style.display='block';
    try{ errEl.scrollIntoView({block:'nearest',behavior:'smooth'}); }catch(_){}
    nb.textContent='Sepete Ekle';
    nb.disabled=false; nb.style.opacity='1';
  });
};
window.kwPrev=function(){if(step>0){goStep(step-1);kwFocusTitle();}};
/* after a step change the pressed button may become disabled/hidden; move focus to the new step's heading (no mobile keyboard pop-up) */
function kwFocusTitle(){
  var h=steps[step]&&steps[step].querySelector('.kw-title'); if(!h) return;
  h.setAttribute('tabindex','-1'); h.style.outline='none';
  try{h.focus({preventScroll:true});}catch(_){h.focus();}
}
/* Canlı önizleme + özet (yan panel, adım 1 önizleme, son adım kartı) — yalnız görünüm, gönderilen veriye dokunmaz */
function kwGen(n){
  var low=n.toLocaleLowerCase('tr'), v='', i;
  for(i=low.length-1;i>=0;i--){ if('aıoueiöü'.indexOf(low[i])>=0){v=low[i];break;} }
  var m={'a':'ı','ı':'ı','o':'u','u':'u','e':'i','i':'i','ö':'ü','ü':'ü'}[v]||'i';
  var endsV='aıoueiöü'.indexOf(low[low.length-1])>=0;
  return n+"'"+(endsV?'n':'')+m+'n';
}
/* 12 Oct: cover preview uses the real book title with the sample hero name swapped for the typed name (Çınar'ın Sevimli Orman Dostları -> Defne'nin Sevimli Orman Dostları). */
var KW_NAMES='Ada Alara Alp Ali Arda Asya Atlas Bade Baran Beren Berk Bora Burak Can Cem Çağla Çınar Defne Demir Derin Doruk Duru Efe Ege Ela Elif Emir Eren Erol Eylül Kaan Kaya Kerem Kerim Kuzey Lara Lina Mavi Melis Mert Mete Mira Naz Nehir Nil Nisan Okan Onur Ömer Öykü Pınar Poyraz Rüya Selin Sude Toprak Tuna Umut Yağmur Yiğit Zeynep'.split(' ');
function kwCoverTitle(nm, tt){
  var t=(tt!=null?String(tt):((overlay&&overlay.getAttribute('data-kw-title'))||'')).split(' | ')[0].split(' - ')[0].split(' – ')[0].trim(), U='A-ZÇĞİÖŞÜ', L='a-zçğıöşüâîû';
  var m=t.match(new RegExp('^(.*?)(['+U+']['+L+']+)[\'’](n?[ıiuü]n)(\\s.*)$'));
  if(m) return m[1]+kwGen(nm)+m[4];
  var w=t.split(' ');
  for(var i=0;i<w.length;i++){ var mm=w[i].match(/^(.+?)([:,.!?]*)$/); if(mm && KW_NAMES.indexOf(mm[1])>=0){ w[i]=nm+mm[2]; return w.join(' '); } }
  return kwGen(nm)+' Masalı';
}
function kwLastV(n){ var low=n.toLocaleLowerCase('tr'); for(var i=low.length-1;i>=0;i--){ if('aıoueiöü'.indexOf(low[i])>=0) return low[i]; } return 'e'; }
function kwEndsV(n){ var low=n.toLocaleLowerCase('tr'); return 'aıoueiöü'.indexOf(low[low.length-1])>=0; }
function kwAbl(n){ var low=n.toLocaleLowerCase('tr'), back='aıou'.indexOf(kwLastV(n))>=0, hard='fsthçşkp'.indexOf(low[low.length-1])>=0; return n+"'"+(hard?'t':'d')+(back?'an':'en'); }
function kwDat(n){ var back='aıou'.indexOf(kwLastV(n))>=0; return n+"'"+(kwEndsV(n)?'y':'')+(back?'a':'e'); }
function kwGiftLine(nm, rel){ rel=(rel||'').trim(); if(!rel || /Diğer/.test(rel)) return kwDat(nm)+' özel bir hediye'; return kwAbl(rel)+' '+kwDat(nm)+' bir hediye'; }
window.msKw={cover:function(t,nm){return kwCoverTitle(nm,t);},gift:kwGiftLine};
function kwSide(){
  var nm=((document.getElementById('kw-name')||{}).value||'').trim();
  var g=gender==='kiz'?'Kız':(gender==='erkek'?'Erkek':'');
  var pc=photoUrls.filter(Boolean).length;
  var pt=uploadingCount>0?'Yükleniyor…':(pc?pc+' fotoğraf':'');
  overlay.querySelectorAll('.kw-pv-name').forEach(function(el){ el.textContent=nm?kwCoverTitle(nm):'Minik kahramanın masalı'; el.classList.toggle('is-set',!!nm); });
  [['name',nm],['gender',g],['photos',pt]].forEach(function(r){
    overlay.querySelectorAll('.kw-v-'+r[0]).forEach(function(el){ el.textContent=r[1]||'—'; el.classList.toggle('is-set',!!r[1]); });
    var li=overlay.querySelector('[data-sum="'+r[0]+'"]'); if(li)li.classList.toggle('is-set',!!r[1]);
  });
}
overlay.addEventListener('click',function(e){if(e.target===overlay)msWizClose()});

function replaceButtons(){
  if(!document.querySelector('.product-information'))return;var addBtn=document.querySelector('button[name="add"]');
  if(addBtn&&!addBtn._msReplaced){
    addBtn._msReplaced=true;
    var newBtn=document.createElement('button');
    newBtn.textContent='Sepete Ekle';
    newBtn.style.cssText='width:100%;padding:14px;background:var(--ms-orange);color:#fff;border:none;border-radius:12px;font-family:Nunito,sans-serif;font-size:15px;font-weight:800;cursor:pointer;margin-top:8px';
    newBtn.addEventListener('click',function(e){e.preventDefault();msWizOpen()});
    addBtn.style.display='none';
    addBtn.parentNode.insertBefore(newBtn,addBtn.nextSibling);
    if(!window.__msStickyIO){
      window.__msStickyIO=true;
      var stickyBar=document.getElementById('ms-new-sticky');
      if(stickyBar){
        stickyBar.style.transition='transform 0.3s ease,opacity 0.3s ease';
        new IntersectionObserver(function(entries){
          entries.forEach(function(e){
            if(e.isIntersecting){stickyBar.style.transform='translateY(100%)';stickyBar.style.opacity='0';stickyBar.style.pointerEvents='none'}
            else{stickyBar.style.transform='translateY(0)';stickyBar.style.opacity='1';stickyBar.style.pointerEvents='auto'}
          });
        },{threshold:0}).observe(newBtn);
      }
    }
  }
}
replaceButtons();
new MutationObserver(replaceButtons).observe(document.body,{childList:true,subtree:true});

document.addEventListener('click',function(e){
  if(!document.querySelector('.product-information'))return;
  var sticky=e.target.closest('.sticky-add-to-cart__button');
  if(sticky){
    e.preventDefault();
    e.stopPropagation();
    if(window.msWizOpen)window.msWizOpen();
  }
},true);
})();

/* 12 Oct (v2, design C): compact "Sepete eklendi" card with the 2-book progress bar. */
(function(){
  var css='.ms-as{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:flex-end;justify-content:center;padding:0 12px calc(14px + env(safe-area-inset-bottom))}'+
  '.ms-as__dim{position:absolute;inset:0;background:rgba(29,34,51,.38);opacity:0;transition:opacity .25s}.ms-as.is-in .ms-as__dim{opacity:1}'+
  '.ms-as__c{position:relative;width:100%;max-width:460px;background:#fff;border-radius:22px;box-shadow:0 18px 40px rgba(29,34,51,.35);padding:16px;color:#2e3a6a;transform:translateY(120%);transition:transform .32s cubic-bezier(.2,.8,.2,1)}'+
  '.ms-as.is-in .ms-as__c{transform:none}'+
  '@media(min-width:760px){.ms-as{align-items:flex-start;justify-content:flex-end;padding:96px 28px 0}.ms-as__c{transform:translateY(-16px);opacity:0;transition:transform .28s,opacity .28s}.ms-as.is-in .ms-as__c{opacity:1}}'+
  '.ms-as__x{position:absolute;right:10px;top:10px;width:32px;height:32px;border:0;border-radius:50%;background:#f3ece2;color:#2e3a6a;font-size:18px;line-height:1;cursor:pointer}'+
  '.ms-as__h{display:flex;gap:12px;align-items:center;padding-right:30px}'+
  '.ms-as__h img{width:58px;flex:none;border-radius:3px 7px 7px 3px;box-shadow:0 8px 18px rgba(46,58,106,.25)}'+
  '.ms-as__ok{font-size:13px;color:#4f8f60;font-weight:800}'+
  '.ms-as__t{font-family:var(--font-heading--family,serif);font-size:17px;line-height:1.2;margin-top:2px}'+
  '.ms-as__pg{margin-top:14px}.ms-as__pt{display:flex;justify-content:space-between;gap:10px;font-size:13px;font-weight:800}.ms-as__pt span{color:#e8914c;text-align:right}.ms-as__pt span.ok{color:#4f8f60}'+
  '.ms-as__bar{height:9px;border-radius:9px;background:#f1e8db;margin-top:8px;overflow:hidden}.ms-as__bar i{display:block;height:100%;border-radius:9px;background:linear-gradient(90deg,#f4a261,#e8914c);transition:width .6s}'+
  '.ms-as__btns{display:flex;gap:10px;margin-top:14px}.ms-as__btns a{flex:1;text-align:center;border-radius:999px;padding:14px 8px;font-weight:800;font-size:14px;text-decoration:none}'+
  '.ms-as__a{background:#fff;border:1.5px solid #2e3a6a;color:#2e3a6a}.ms-as__z{background:#f4a261;color:#fff;box-shadow:0 8px 20px rgba(244,162,97,.35)}';
  function esc(t){ var d=document.createElement('div'); d.textContent=t==null?'':String(t); return d.innerHTML; }
  window.msAddedSheet=function(o){
    if(!document.getElementById('ms-as-css')){ var st=document.createElement('style'); st.id='ms-as-css'; st.textContent=css; document.head.appendChild(st); }
    try{ if(window.msWizClose) window.msWizClose(); }catch(_){}
    var old=document.querySelector('.ms-as'); if(old) old.remove();
    var it=o.item||{}, img=(it.image||((document.querySelector('.kw-cover img')||{}).src)||'');
    if(img && img.indexOf('width=')<0) img+=(img.indexOf('?')<0?'?':'&')+'width=160';
    var root=document.createElement('div'); root.className='ms-as'; root.setAttribute('role','dialog'); root.setAttribute('aria-label','Sepete eklendi');
    root.innerHTML='<div class="ms-as__dim" data-x></div><div class="ms-as__c"><button type="button" class="ms-as__x" data-x aria-label="Kapat">×</button>'+
      '<div class="ms-as__h">'+(img?'<img src="'+esc(img)+'" alt="">':'')+'<div><div class="ms-as__ok">✓ Sepete eklendi</div><div class="ms-as__t">'+esc(o.title||'')+'</div></div></div>'+
      '<div class="ms-as__pg"><div class="ms-as__pt"><b>Sepetiniz</b><span></span></div><div class="ms-as__bar"><i style="width:0"></i></div></div>'+
      '<div class="ms-as__btns"><a class="ms-as__a" href="/cart#ms-oneri">+ Masal ekle</a><a class="ms-as__z" href="/cart">Sepete git →</a></div></div>';
    document.body.appendChild(root);
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ root.classList.add('is-in'); }); });
    function close(){ root.classList.remove('is-in'); setTimeout(function(){ root.remove(); },320); }
    root.addEventListener('click',function(e){ if(e.target.closest('[data-x]')) close(); });
    fetch('/cart.js').then(function(r){return r.json()}).then(function(c){
      var n=c.item_count||1, pt=root.querySelector('.ms-as__pt'), bar=root.querySelector('.ms-as__bar i');
      pt.querySelector('b').textContent=Math.min(n,2)+' / 2 kitap';
      var sp=pt.querySelector('span');
      if(n>=2){ sp.textContent='✓ %10 indirim uygulandı'; sp.className='ok'; bar.style.width='100%'; }
      else { sp.textContent='%10 indirime 1 kitap kaldı'; bar.style.width='50%'; }
      document.querySelectorAll('[data-cart-count], .cart-count-bubble span, .msb-bn2__badge').forEach(function(el){ el.textContent=n; });
    }).catch(function(){});
  };
})();
